import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';

import moment from 'common/moment';

import { requestDailySalesReportDataAction } from '../actions';
import { DailySalesReport } from './index';

const getDailySalesReportData = (state) => state.salesReport.dailySales.reportData;

const getTransformedDailySalesReportData = createSelector(
  [getDailySalesReportData],
  (reportData) => {
    if (!reportData) {
      return null;
    }

    return {
      ...reportData,
      rows: reportData.rows.map((row) => ({
        ...row,
        date: moment(row.date),
      })),
    };
  },
);

const mapStateToProps = (state) => ({
  displayState: state.salesReport.dailySales.displayState,
  reportData: getTransformedDailySalesReportData(state),
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ requestDailySalesReportDataAction }, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DailySalesReport);
